<template>
  <nav
    v-if="total > 0"
    class="mx-auto w-full"
    :aria-label="`${itemLabel} pagination`"
  >
    <div class="flex items-center justify-center gap-3 text-sm sm:gap-5">
      <button
        type="button"
        class="inline-flex h-9 shrink-0 items-center gap-1.5 text-stone-400 transition-colors enabled:hover:text-stone-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 disabled:cursor-not-allowed disabled:opacity-25 dark:text-stone-500 dark:enabled:hover:text-white"
        :disabled="page <= 1"
        aria-label="Previous page"
        @click="goToPage(page - 1)"
      >
        <span aria-hidden="true">←</span>
        <span>Previous</span>
      </button>

      <span class="h-4 w-px bg-stone-200 dark:bg-stone-700" aria-hidden="true" />

      <span class="shrink-0 font-medium tabular-nums text-stone-900 dark:text-white" aria-live="polite">
        Page {{ page }} of {{ totalPages }}
      </span>

      <span class="h-4 w-px bg-stone-200 dark:bg-stone-700" aria-hidden="true" />

      <button
        type="button"
        class="inline-flex h-9 shrink-0 items-center gap-1.5 text-stone-400 transition-colors enabled:hover:text-stone-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 disabled:cursor-not-allowed disabled:opacity-25 dark:text-stone-500 dark:enabled:hover:text-white"
        :disabled="page >= totalPages"
        aria-label="Next page"
        @click="goToPage(page + 1)"
      >
        <span>Next</span>
        <span aria-hidden="true">→</span>
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  total: number
  perPage: number
  itemLabel?: string
}>(), {
  itemLabel: 'items',
})

const page = defineModel<number>('page', { required: true })

const totalPages = computed(() => Math.max(1, Math.ceil(props.total / props.perPage)))

const goToPage = (targetPage: number) => {
  page.value = Math.min(totalPages.value, Math.max(1, targetPage))
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}
</script>
